import { render, staticRenderFns } from "./changeInternalRemarks.vue?vue&type=template&id=61332e93&scoped=true"
import script from "./changeInternalRemarks.vue?vue&type=script&lang=js"
export * from "./changeInternalRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61332e93",
  null
  
)

export default component.exports